module.exports = __webpack_public_path__ + "img/268-1.0dcbc080.png";